// extracted by mini-css-extract-plugin
export default {"pannel_footer":"PannelFooter_pannel_footer__Dieo9","large":"PannelFooter_large__QSVg8","pannel_body":"PannelFooter_pannel_body__51X86"};